export function roundNumber({
  value,
  decimals,
  truncate,
}: {
  value: number | string;
  decimals?: number;
  truncate?: boolean;
  // TODO: refactor usage to remove any from return type
}): number {
  const factor = 10 ** (decimals ?? 0);
  const parsedValue = typeof value === 'string' ? parseFloat(value) : value;
  const roundFunction = truncate ? Math.floor : Math.round;
  const result = roundFunction((parsedValue + Number.EPSILON) * factor) / factor;

  if (isFinite(result) && !isNaN(result)) {
    return result;
  } else {
    return 0;
  }
}
